/** Namespace `invoiceQuota` — PLAT-2026-156 · ADR-049: màn « Lượt hoá đơn » (sổ lượt ở bube-einvoice), bản gốc tiếng Việt. */
export const invoiceQuota = {
  title: "Lượt hoá đơn",
  subtitle:
    "Sổ lượt phát hành hoá đơn của Bube nằm ở bube-einvoice; hub chỉ gửi lệnh và hiển thị. Hub tắt không ảnh hưởng việc phát hành của khách.",
  searchPlaceholder: "Tìm khách theo tên, slug, id hoặc mã số thuế",
  search: "Tìm",
  empty: "Không có khách nào khớp.",
  loadFailed: "Không đọc được dữ liệu từ bube-einvoice.",
  back: "← Danh sách khách",
  noEntity: "Khách chưa có pháp nhân phát hành — lệnh ghi đầu tiên (chính sách hoặc cấp lượt) sẽ tạo pháp nhân chính.",
  workspaceTitle: "Lượt hoá đơn của « {name} »",
  noScopes: "Khách chưa gắn nhà cung cấp hoá đơn nào.",

  dirOUTBOUND: "Hoá đơn đầu ra (bán ra)",
  dirINBOUND: "Hoá đơn đầu vào (mua vào)",
  model_bube_ledger: "Sổ lượt Bube",
  model_provider_managed: "Nhà cung cấp tự quản",
  model_unmanaged: "Chưa chuyển đổi",
  enf_disabled: "Chưa cưỡng chế",
  enf_preparing: "Đang chuẩn bị — tạm dừng hoá đơn mới",
  enf_enforced: "Đang cưỡng chế",

  granted: "Đã cấp ròng",
  consumed: "Đã dùng",
  held: "Đang giữ",
  available: "Khả dụng",
  revision: "Phiên bản sổ",
  asOf: "Tính đến {at}",
  providerManagedNote: "Số lượng do {provider} quản lý — Bube không giữ số dư (không phải 0).",
  unmanagedNote: "Phạm vi chưa chuyển sang sổ Bube — phát hành như cũ, không kiểm lượt.",
  inboundNote: "Hoá đơn đầu vào không dùng lượt phát hành.",
  noAccount: "Chưa có sổ cho phạm vi này.",

  actionGrant: "Cấp thêm",
  actionPolicy: "Chính sách",
  actionLedger: "Xem sổ",
  actionHideLedger: "Ẩn sổ",
  noGrantPermission: "Bạn không có quyền cấp thêm lượt.",
  noPolicyPermission: "Bạn không có quyền đổi chính sách.",

  grantTitle: "Cấp thêm lượt — {provider} · {direction}",
  amount: "Số lượt cấp thêm",
  kind: "Loại căn cứ",
  kind_purchase: "Khách mua",
  kind_gift: "Tặng",
  kind_compensation: "Bù",
  kind_transfer: "Chuyển số dư",
  kind_opening: "Số dư mở đầu",
  reason: "Lý do (ít nhất 3 ký tự)",
  documentSource: "Nguồn chứng từ",
  documentRef: "Mã chứng từ",
  documentLine: "Dòng chứng từ",
  documentHint: "Có mã chứng từ thì cùng chứng từ/dòng không thể cấp hai lần, dù đổi lệnh.",
  preview: "Khả dụng: {before} → {after}",
  commandHint: "Mã lệnh {id} được giữ khi tải lại; gửi lại dùng đúng mã này nên không cộng lặp.",
  confirm: "Ghi nhận cấp",
  confirmAgain: "Bấm lần nữa để xác nhận",
  cancel: "Huỷ",
  saving: "Đang ghi…",
  saved: "Đã ghi nhận.",
  replayed: "Lệnh này đã được ghi trước đó — không cộng lại.",
  checkCommand: "Kiểm tra kết quả lệnh",
  commandFound: "Lệnh đã được ghi — số dư đã cập nhật.",
  commandMissing: "Lệnh chưa được ghi; có thể gửi lại an toàn.",

  reverseTitle: "Đảo / bù khoản cấp",
  reverseAmount: "Số lượt đảo (tối đa {max})",
  reverseConfirm: "Ghi nhận đảo",
  reversible: "Còn đảo được {n}",
  actionReverse: "Đảo / bù",
  noReversePermission: "Bạn không có quyền đảo/bù.",

  policyTitle: "Chính sách — {provider} · {direction}",
  policyModel: "Mô hình cấp phát",
  policyEnforcement: "Cưỡng chế",
  policyHint: "Chỉ « Sổ lượt Bube » mới cưỡng chế được. Đổi mô hình không xoá sổ cũ.",
  policyEnforceWarn: "Cưỡng chế: hoá đơn mới bị chặn khi hết lượt. Cấp lượt đầu kỳ trước khi bật.",
  policyConfirm: "Lưu chính sách",

  colTime: "Thời điểm",
  colType: "Loại",
  colDelta: "Thay đổi",
  colActor: "Người / hệ thống",
  colReason: "Lý do",
  colRevision: "Phiên bản",
  type_grant: "Cấp",
  type_reserve: "Giữ chỗ",
  type_consume: "Đã dùng",
  type_release: "Trả lượt",
  type_adjust: "Đảo / bù",
  ledgerEmpty: "Chưa có bút toán.",

  err_INVOICE_QUOTA_DOCUMENT_DUPLICATE: "Chứng từ/dòng này đã được cấp lượt trước đó.",
  err_INVOICE_QUOTA_COMMAND_CONFLICT: "Mã lệnh này đã dùng cho nội dung khác — mở lại biểu mẫu để tạo lệnh mới.",
  err_INVOICE_QUOTA_REVISION_CONFLICT: "Sổ vừa thay đổi ở nơi khác — tải lại rồi thử lại.",
  err_INVOICE_QUOTA_NOT_BUBE_MANAGED: "Phạm vi này không dùng sổ lượt của Bube.",
  err_INVOICE_QUOTA_SCOPE_NOT_CONFIGURED: "Phạm vi chưa được cấu hình sổ lượt.",
  err_INVOICE_QUOTA_DIRECTION_DISABLED: "Hướng hoá đơn này không dùng lượt phát hành.",
  err_INVOICE_QUOTA_ADJUST_EXCEEDS: "Số lượt đảo vượt mức cho phép (không thu hồi lượt đang giữ hoặc đã dùng).",
  err_unknown: "Không thực hiện được.",

  blockedInvoices: "{n} hoá đơn đang chờ lượt (giữ ở trạng thái sẵn sàng, tự chạy lại khi có lượt)",

  fulfillTitle: "Đáp ứng đối tác",
  fulfillHint: "Quyền Bube đã có hiệu lực ngay khi ghi sổ. Đây chỉ là việc đã làm ở phía nhà cung cấp — thành công hay thất bại đều không đổi số dư.",
  ful_unverified: "Chưa xác minh",
  ful_dashboard_done: "Đã cấp ở dashboard",
  ful_api_requested: "Đã gửi API — chờ / chưa rõ",
  ful_api_succeeded: "API thành công",
  ful_api_failed: "API thất bại",
  ful_api_unsupported: "Nhà/kênh chưa hỗ trợ API",
  ful_needs_reconcile: "Cần đối chiếu với nhà cung cấp",
  fulMarkDashboard: "Đã cấp ở dashboard",
  fulRequestApi: "Yêu cầu qua API",
  fulEvidence: "Mã tham chiếu / bằng chứng",
  fulNote: "Ghi chú",
  fulNoPermission: "Bạn không có quyền ghi nhận đáp ứng đối tác.",
  fulReconcileHint: "API đang chờ nhưng đã có người xử lý ở dashboard: kiểm tra với nhà trước khi làm tiếp, hub không tự gửi lại.",
  fulDone: "Đã ghi nhận đáp ứng.",
  grantsHeading: "Các khoản cấp",
  err_INVOICE_QUOTA_FULFILLMENT_CONFLICT: "Khoản cấp này đã có đáp ứng đối tác hoặc đang cần đối chiếu — không gửi thêm.",
  err_INVOICE_QUOTA_CUTOVER_BLOCKED: "Chưa đủ điều kiện chuyển sang cưỡng chế.",
  err_INVOICE_QUOTA_CUTOVER_STATE: "Bước này không hợp lệ ở trạng thái hiện tại của đợt chuyển.",

  actionCutover: "Chuyển đổi",
  cutoverTitle: "Chuyển phạm vi sang sổ Bube — {provider}",
  cutoverIntro: "Quy trình có thứ tự: bắt đầu (tạm dừng hoá đơn MỚI để drain) → số dư mở đầu (một lần) → cưỡng chế. Lịch sử phát hành trước mốc bắt đầu không bị tính vào sổ.",
  cutoverId: "Mã đợt chuyển",
  cutoverNone: "Chưa bắt đầu đợt này.",
  cutoverState: "Trạng thái: {state}",
  cst_preparing: "Đang chuẩn bị",
  cst_balanced: "Đã có số dư mở đầu",
  cst_enforced: "Đã cưỡng chế",
  cst_rolled_back: "Đã rollback",
  cutoverWatermark: "Mốc lịch sử: {n} hoá đơn đã phát hành (tính đến {at}) — không tính vào sổ.",
  cutoverInFlight: "Đang bay: {processing} đang xử lý ở nhà · {ready} đã xếp hàng · {holds} giữ chỗ treo · {waiting} đang chờ",
  cutoverBegin: "Bắt đầu (tạm dừng hoá đơn mới)",
  cutoverOpening: "Ghi số dư mở đầu",
  cutoverOpeningAmount: "Số dư mở đầu (lượt còn lại theo hồ sơ đối chiếu)",
  cutoverEnforce: "Bật cưỡng chế",
  cutoverRollback: "Rollback (giữ nguyên sổ)",
  cutoverRollbackHint: "Rollback chỉ tắt cưỡng chế; grant, lượt đã dùng và giữ chỗ được giữ nguyên. Hoá đơn phát hành lúc cưỡng chế tắt không được ghi vào sổ.",
  cutoverReady: "Đủ điều kiện bật cưỡng chế.",
  blk_state: "Chưa ở bước «đã có số dư mở đầu»",
  blk_in_flight: "Còn hoá đơn đang xử lý hoặc đã xếp hàng chưa drain",
  blk_holds: "Còn giữ chỗ treo chưa chốt/trả",
  blk_no_opening_balance: "Chưa có số dư mở đầu lớn hơn 0 (không bao giờ bật với số dư 0)",
  blk_projection_mismatch: "Số dư lệch tổng sổ — cần điều tra, không tự sửa",
  cutoverNeedsPolicy: "Cần quyền đổi chính sách.",
} as const;
